import { render, staticRenderFns } from "./approvalList.vue?vue&type=template&id=6bbe51f6&scoped=true&"
import script from "./approvalList.vue?vue&type=script&lang=js&"
export * from "./approvalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe51f6",
  null
  
)

export default component.exports